import { Button } from '../ui/button';
import { RotateCw } from 'lucide-react';
import type { PrintRatioConfig } from '@/types';

interface CropperHeaderProps {
  config: PrintRatioConfig;
  orientation: 'portrait' | 'landscape';
  onReset: () => void;
}

/**
 * CropperHeader Component
 * 
 * Displays the current ratio information and reset button
 */
export function CropperHeader({ config, orientation, onReset }: CropperHeaderProps) {
  return (
    <div className="p-4 border-b bg-muted/30">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold">
            {config.label} - {orientation === 'portrait' ? 'Portrait' : 'Landscape'}
          </h3>
          <p className="text-sm text-muted-foreground">
            Target: {orientation === 'portrait'
              ? `${config.width} × ${config.height}px`
              : `${config.height} × ${config.width}px`}
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={onReset}>
          <RotateCw className="h-4 w-4 mr-2" />
          Reset
        </Button>
      </div>
    </div>
  );
}

